import BrowsePicksSearchPillCollection from "@/classes/stock/BrowsePicksSearchPillCollection";
import StockSearchItem from "@/classes/stock/StockSearchItem";
import GridColumn from "@/classes/component-classes/GridColumn";
import {ViewShipment} from "@/classes/viewmodels/ViewShipment";

export default class BrowsePicks {
    constructor() {

        this.openDocumentsDrawer = false;
        this.hideExcelDownloadBusy = true
        this.lineGridCurrentPage = 1;
        this.lineGridPageRange = 1
        this.searchData = [];
        this.shipmentDocs = [];
        this.isSearchData = false;
        this.skuGroups =[];

        this.searchCriteria = new StockSearchItem();

        this.searchPills = new BrowsePicksSearchPillCollection();
        this.searchPillGroupTwo = false;
        this.searchGridCurrentPage = 1;
        this.searchGridPageRange = 1;

        this.viewShipment = new ViewShipment();

        this.gridColumns = [

            new GridColumn('1', 'Docs', 'documents', '30', true, false),
            new GridColumn('11', 'Complete', 'complete', '30', true, false),
            new GridColumn('2', 'Warehouse Ref', 'warehouseRef', '140', true, false),
            new GridColumn('3','Customer Ref', 'customerRef', '140', true, false),
            new GridColumn('4', 'Job Ref', 'shipmentRef', '100', true, false),
            new GridColumn('8', 'Deliver To', 'deliverTo', '260', true, false),
            new GridColumn('6', 'Release Date', 'releaseDate', '60', true, false),
            new GridColumn('7', 'Release By', 'releasedBy', '160', true, false),
            new GridColumn('9','Delivery Date', 'deliveryDate', '68', true, false ),
            new GridColumn('10', 'Delivery Instructions', 'instructions', '250', true, false),
            new GridColumn('12','Notification', 'notified', '50', true, false)

        ]


    }
}
